import * as React from 'react';
export const externalSvg = React.forwardRef(function externalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 1.75A.75.75 0 0 1 8.75 1h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V3.56l-7.095 7.095a.75.75 0 1 1-1.06-1.06L12.439 2.5H8.75A.75.75 0 0 1 8 1.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.5 4.75c0-.69.56-1.25 1.25-1.25h1.875a.75.75 0 0 0 0-1.5H3.75A2.75 2.75 0 0 0 1 4.75v7.5A2.75 2.75 0 0 0 3.75 15h7.5A2.75 2.75 0 0 0 14 12.25v-1.875a.75.75 0 0 0-1.5 0v1.875c0 .69-.56 1.25-1.25 1.25h-7.5c-.69 0-1.25-.56-1.25-1.25v-7.5Z',
    }),
  );
});
externalSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var external = {
  category: 'icon',
  colorable: true,
  name: 'external',
  svg: externalSvg,
};
